import type { Styles } from 'src/theme/themes';

export const styles = {
  accordionItemPanel: (theme) => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    height: '100%',
  }),

  collapseWrapper: {
    height: '100%',
    '& .MuiCollapse-wrapper': {
      height: '100%',
    },
    '& .MuiCollapse-wrapperInner': {
      height: '100%',
    },
  },
} satisfies Styles;
